import { getUserFriendlyError } from '../utils/errors';
import { requestNotificationsRefresh } from '../utils/notificationEvents';
import * as meetingApi from './meetingApi';

// The ONE web implementation of "delete this meeting permanently" -
// mirrors services/meetingEnd.js's shape so useDeleteMeeting.js can
// mirror hooks/useEndMeeting.js. Unlike ending a meeting, a delete has
// no ambiguous in-between state to reconcile: either the backend says
// it's gone (204) or it doesn't.
//
// A 404 is treated as SUCCESS, not an error: it means the meeting is
// already gone - deleted a moment ago from another tab, from desktop,
// or by a previous click that actually landed - so the row disappearing
// from this list is exactly the right outcome (see the task's race-
// condition handling). A 409 (MEETING_STILL_ACTIVE) and everything else
// is a real failure - the row stays, with a message.
//
// Returns { deleted, errorMessage, code }.
export async function deleteMeeting(meetingId) {
  try {
    await meetingApi.deleteMeeting(meetingId);
  } catch (err) {
    if (err.status === 404) {
      return { deleted: true, errorMessage: '', code: null };
    }

    return {
      deleted: false,
      errorMessage: getUserFriendlyError(
        err,
        'Unable to delete meeting. Please try again.'
      ),
      code: err.code || null,
    };
  }

  // A deleted meeting can no longer be "still active" - have the bell
  // stop referencing it, same reasoning as services/meetingEnd.js.
  requestNotificationsRefresh();

  return { deleted: true, errorMessage: '', code: null };
}
